
export default function(rows,filters){

  var data = []

  var totalFilters = _.size(filters)

  for(var row of rows){

    if(totalFilters == 0){
      data.push(row)

    } else {

      var matchedFilters = 0
      var columns = row.columns

      for(var id in filters){

        var filter = filters[id]

        var column = _.find(columns, {id: id})

        var filterMatch = column.type.filterMatch(column,filter)

        if(filterMatch){
          matchedFilters++
        }

      }

      if(totalFilters == matchedFilters){
        data.push(row)
      }

    }
  }

  return data

}



// WEBPACK FOOTER //
// ./src/client/view/admin/search/table/lib/update/filter/filter.js